export default __webpack_public_path__ + "static/media/modal_delete_image.8ea2baa0.svg";